module.exports = __webpack_public_path__ + "static/media/Block-Barrel-Spring.26c4b7b8.jpg";